import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "settings-list" }
const _hoisted_2 = { class: "settings-card settings-card--theme" }
const _hoisted_3 = { class: "settings-card settings-card--legal" }
const _hoisted_4 = { class: "settings-legal-links" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "settings-legal-payee" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_HeaderMessengerButton = _resolveComponent("HeaderMessengerButton")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border events-page-header" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { onClick: _ctx.openMenu }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.menuOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("Настройки", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_HeaderMessengerButton)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "main-background settings-content",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "settings-theme-label" }, "Тема", -1)),
              _createVNode(_component_ion_segment, {
                mode: "ios",
                class: "liga-glass-segment settings-theme-segment",
                value: _ctx.appearance,
                onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAppearanceChange($event)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_segment_button, {
                    mode: "ios",
                    value: "system"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("Авто", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_segment_button, {
                    mode: "ios",
                    value: "dark"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("Тёмная", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_segment_button, {
                    mode: "ios",
                    value: "light"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode("Светлая", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]),
              _cache[11] || (_cache[11] = _createElementVNode("p", { class: "settings-theme-hint" }, "Автоматически — по теме устройства", -1))
            ]),
            _createVNode(_component_ion_item, {
              class: "settings-card",
              lines: "none"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode("Меню справа", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_ion_toggle, {
                  "aria-label": "Меню справа",
                  onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.menuButtonChange($event))),
                  checked: _ctx.menuButton.position === 'right'
                }, null, 8, ["checked"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, {
              class: "settings-card",
              lines: "none"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("Кэш", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_ion_label, {
                  slot: "end",
                  class: "settings-meta"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.bufferSizeHuman), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, !_ctx.removingCache]
                ]),
                _withDirectives(_createVNode(_component_ion_icon, {
                  icon: _ctx.trashOutline,
                  class: "settings-action-icon",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearCacheExceptPlaylists('/'))),
                  slot: "end"
                }, null, 8, ["icon"]), [
                  [_vShow, _ctx.bufferSize > 0 && !_ctx.removingCache]
                ]),
                _withDirectives(_createVNode(_component_ion_spinner, {
                  name: "bubbles",
                  slot: "end"
                }, null, 512), [
                  [_vShow, _ctx.removingCache]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, {
              class: "settings-card",
              lines: "none"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("Память устройства", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_ion_label, {
                  slot: "end",
                  class: "settings-meta"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(`${_ctx.deviceDiskFreeHuman} из ${_ctx.deviceDiskTotalHuman}`), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.isAuthenticated)
              ? (_openBlock(), _createBlock(_component_ion_item, {
                  key: 0,
                  class: "settings-card settings-card--nav",
                  button: "",
                  detail: "",
                  lines: "none",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'MessengerPrivacySettings' })))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createElementVNode("h2", null, "Liga.Chat / Приватность", -1),
                        _createElementVNode("p", null, "Видимость профиля и личные сообщения", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("a", {
                  href: _ctx.LEGAL.offerUrl,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "settings-legal-link"
                }, "Оферта", 8, _hoisted_5),
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "settings-legal-sep" }, "|", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "settings-legal-link",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'PrivacyPolicy' })))
                }, " Конфиденциальность "),
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "settings-legal-sep" }, "|", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "settings-legal-link",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ name: 'OfferSupplement' })))
                }, " Возвраты ")
              ]),
              _createElementVNode("p", _hoisted_6, [
                _cache[18] || (_cache[18] = _createTextVNode(" Платежи принимает: ", -1)),
                _createElementVNode("a", {
                  href: _ctx.LEGAL.offerUrl,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "settings-legal-link"
                }, _toDisplayString(_ctx.LEGAL.payeeShortName), 9, _hoisted_7)
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}